// extracted by mini-css-extract-plugin
module.exports = {"container":"ourStory_container__MVv2P","desc":"ourStory_desc__c2eFP"};